import axios from "../../api/axios";
import Cookies from "js-cookie";

import { useDispatch } from "react-redux";

import { setAuth } from "../../features/authProvider/authProviderSlice";

import { resetCartQuantity } from "../../features/cartQuantity/cartQuantitySlice";

const useLogout = () => {
  const dispatch = useDispatch();

  const logout = async () => {
    dispatch(setAuth({}));
    dispatch(resetCartQuantity(0));

    Cookies.remove("jwt", {
      path: "/",
      secure: true,
      sameSite: "None",
    });

    try {
      await axios("/logout", {
        withCredentials: true,
      });
    } catch (err) {
      console.error(err);
    }
  };

  return logout;
};

export default useLogout;
